import { render, staticRenderFns } from "./AssistantChat.vue?vue&type=template&id=f90301ea&scoped=true&"
import script from "./AssistantChat.vue?vue&type=script&lang=js&"
export * from "./AssistantChat.vue?vue&type=script&lang=js&"
import style0 from "./AssistantChat.vue?vue&type=style&index=0&id=f90301ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90301ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f90301ea')) {
      api.createRecord('f90301ea', component.options)
    } else {
      api.reload('f90301ea', component.options)
    }
    module.hot.accept("./AssistantChat.vue?vue&type=template&id=f90301ea&scoped=true&", function () {
      api.rerender('f90301ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AssistantChat.vue"
export default component.exports